module.exports = __webpack_public_path__ + "dropify.4e8b017aef78cc114006.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/src/assets/js/plugins/dropify/fonts/dropify.eot
// module id = ../../../../../src/assets/js/plugins/dropify/fonts/dropify.eot
// module chunks = 29